/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FeesDto } from './FeesDto';
import {
    FeesDtoFromJSON,
    FeesDtoFromJSONTyped,
    FeesDtoToJSON,
    FeesDtoToJSONTyped,
} from './FeesDto';
import type { BorrowerPricingDto } from './BorrowerPricingDto';
import {
    BorrowerPricingDtoFromJSON,
    BorrowerPricingDtoFromJSONTyped,
    BorrowerPricingDtoToJSON,
    BorrowerPricingDtoToJSONTyped,
} from './BorrowerPricingDto';
import type { TarificationDto } from './TarificationDto';
import {
    TarificationDtoFromJSON,
    TarificationDtoFromJSONTyped,
    TarificationDtoToJSON,
    TarificationDtoToJSONTyped,
} from './TarificationDto';
import type { LoanConfigurationDto } from './LoanConfigurationDto';
import {
    LoanConfigurationDtoFromJSON,
    LoanConfigurationDtoFromJSONTyped,
    LoanConfigurationDtoToJSON,
    LoanConfigurationDtoToJSONTyped,
} from './LoanConfigurationDto';
import type { FunnelProductDto } from './FunnelProductDto';
import {
    FunnelProductDtoFromJSON,
    FunnelProductDtoFromJSONTyped,
    FunnelProductDtoToJSON,
    FunnelProductDtoToJSONTyped,
} from './FunnelProductDto';
import type { GuaranteeDto1 } from './GuaranteeDto1';
import {
    GuaranteeDto1FromJSON,
    GuaranteeDto1FromJSONTyped,
    GuaranteeDto1ToJSON,
    GuaranteeDto1ToJSONTyped,
} from './GuaranteeDto1';
import type { ReadVariablesTunnelDto } from './ReadVariablesTunnelDto';
import {
    ReadVariablesTunnelDtoFromJSON,
    ReadVariablesTunnelDtoFromJSONTyped,
    ReadVariablesTunnelDtoToJSON,
    ReadVariablesTunnelDtoToJSONTyped,
} from './ReadVariablesTunnelDto';
import type { ComparateurPricingStatus } from './ComparateurPricingStatus';
import {
    ComparateurPricingStatusFromJSON,
    ComparateurPricingStatusFromJSONTyped,
    ComparateurPricingStatusToJSON,
    ComparateurPricingStatusToJSONTyped,
} from './ComparateurPricingStatus';

/**
 * Borrower contract funnel with async pricing status (v2 - SignalR)
 * @export
 * @interface BorrowerContractFunnelV2Dto
 */
export interface BorrowerContractFunnelV2Dto {
    /**
     * 
     * @type {string}
     * @memberof BorrowerContractFunnelV2Dto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerContractFunnelV2Dto
     */
    name: string;
    /**
     * 
     * @type {ComparateurPricingStatus}
     * @memberof BorrowerContractFunnelV2Dto
     */
    pricingStatus: ComparateurPricingStatus;
    /**
     * 
     * @type {FunnelProductDto}
     * @memberof BorrowerContractFunnelV2Dto
     */
    product: FunnelProductDto;
    /**
     * 
     * @type {Array<FeesDto>}
     * @memberof BorrowerContractFunnelV2Dto
     */
    fees?: Array<FeesDto>;
    /**
     * 
     * @type {Array<ReadVariablesTunnelDto>}
     * @memberof BorrowerContractFunnelV2Dto
     */
    variables?: Array<ReadVariablesTunnelDto>;
    /**
     * 
     * @type {TarificationDto}
     * @memberof BorrowerContractFunnelV2Dto
     */
    pricing?: TarificationDto;
    /**
     * 
     * @type {Array<LoanConfigurationDto>}
     * @memberof BorrowerContractFunnelV2Dto
     */
    loanConfigs: Array<LoanConfigurationDto>;
    /**
     * 
     * @type {Array<GuaranteeDto1>}
     * @memberof BorrowerContractFunnelV2Dto
     */
    guarantees: Array<GuaranteeDto1>;
    /**
     * All available guarantees for this contract funnel
     * @type {Array<GuaranteeDto1>}
     * @memberof BorrowerContractFunnelV2Dto
     */
    guaranteesReferential?: Array<GuaranteeDto1>;
    /**
     * 
     * @type {string}
     * @memberof BorrowerContractFunnelV2Dto
     */
    supportId: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerContractFunnelV2Dto
     */
    supportLabel: string;
    /**
     * Cotisation type identifier (CI or CRD)
     * @type {string}
     * @memberof BorrowerContractFunnelV2Dto
     */
    cotisationTypeId?: string | null;
    /**
     * Cotisation type label
     * @type {string}
     * @memberof BorrowerContractFunnelV2Dto
     */
    cotisationTypeLabel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BorrowerContractFunnelV2Dto
     */
    contractIdentifier: string;
    /**
     * Match score percentage (0-100)
     * @type {number}
     * @memberof BorrowerContractFunnelV2Dto
     */
    matchScore?: number | null;
    /**
     * List of missing guarantee names
     * @type {Array<string>}
     * @memberof BorrowerContractFunnelV2Dto
     */
    missingGuarantees?: Array<string> | null;
    /**
     * Unique hash identifying this contract funnel configuration
     * @type {string}
     * @memberof BorrowerContractFunnelV2Dto
     */
    hash: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BorrowerContractFunnelV2Dto
     */
    warningMessages?: Array<string> | null;
    /**
     * 
     * @type {Array<BorrowerPricingDto>}
     * @memberof BorrowerContractFunnelV2Dto
     */
    borrowers: Array<BorrowerPricingDto>;
    /**
     * MNCAP borrower ID for PDF simulation generation
     * @type {string}
     * @memberof BorrowerContractFunnelV2Dto
     */
    mncapBorrowerId?: string | null;
    /**
     * Indicates if insured selection is required (group offer with more than 2 insureds)
     * @type {boolean}
     * @memberof BorrowerContractFunnelV2Dto
     */
    hasSelection?: boolean;
    /**
     * Indicates if the borrower is eligible for the Lemoine provision
     * @type {boolean}
     * @memberof BorrowerContractFunnelV2Dto
     */
    isCasLemoine: boolean;
    /**
     * Indicates if this contract funnel has custom fees different from the global fees
     * @type {boolean}
     * @memberof BorrowerContractFunnelV2Dto
     */
    isEdition?: boolean;
    /**
     * Error message from pricing calculation when pricingStatus is Error or Timeout
     * @type {string}
     * @memberof BorrowerContractFunnelV2Dto
     */
    errorMessage?: string | null;
}



/**
 * Check if a given object implements the BorrowerContractFunnelV2Dto interface.
 */
export function instanceOfBorrowerContractFunnelV2Dto(value: object): value is BorrowerContractFunnelV2Dto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('pricingStatus' in value) || value['pricingStatus'] === undefined) return false;
    if (!('product' in value) || value['product'] === undefined) return false;
    if (!('loanConfigs' in value) || value['loanConfigs'] === undefined) return false;
    if (!('guarantees' in value) || value['guarantees'] === undefined) return false;
    if (!('supportId' in value) || value['supportId'] === undefined) return false;
    if (!('supportLabel' in value) || value['supportLabel'] === undefined) return false;
    if (!('contractIdentifier' in value) || value['contractIdentifier'] === undefined) return false;
    if (!('hash' in value) || value['hash'] === undefined) return false;
    if (!('borrowers' in value) || value['borrowers'] === undefined) return false;
    if (!('isCasLemoine' in value) || value['isCasLemoine'] === undefined) return false;
    return true;
}

export function BorrowerContractFunnelV2DtoFromJSON(json: any): BorrowerContractFunnelV2Dto {
    return BorrowerContractFunnelV2DtoFromJSONTyped(json, false);
}

export function BorrowerContractFunnelV2DtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerContractFunnelV2Dto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'pricingStatus': ComparateurPricingStatusFromJSON(json['pricingStatus']),
        'product': FunnelProductDtoFromJSON(json['product']),
        'fees': json['fees'] == null ? undefined : ((json['fees'] as Array<any>).map(FeesDtoFromJSON)),
        'variables': json['variables'] == null ? undefined : ((json['variables'] as Array<any>).map(ReadVariablesTunnelDtoFromJSON)),
        'pricing': json['pricing'] == null ? undefined : TarificationDtoFromJSON(json['pricing']),
        'loanConfigs': ((json['loanConfigs'] as Array<any>).map(LoanConfigurationDtoFromJSON)),
        'guarantees': ((json['guarantees'] as Array<any>).map(GuaranteeDto1FromJSON)),
        'guaranteesReferential': json['guaranteesReferential'] == null ? undefined : ((json['guaranteesReferential'] as Array<any>).map(GuaranteeDto1FromJSON)),
        'supportId': json['supportId'],
        'supportLabel': json['supportLabel'],
        'cotisationTypeId': json['cotisationTypeId'] == null ? undefined : json['cotisationTypeId'],
        'cotisationTypeLabel': json['cotisationTypeLabel'] == null ? undefined : json['cotisationTypeLabel'],
        'contractIdentifier': json['contractIdentifier'],
        'matchScore': json['matchScore'] == null ? undefined : json['matchScore'],
        'missingGuarantees': json['missingGuarantees'] == null ? undefined : json['missingGuarantees'],
        'hash': json['hash'],
        'warningMessages': json['warningMessages'] == null ? undefined : json['warningMessages'],
        'borrowers': ((json['borrowers'] as Array<any>).map(BorrowerPricingDtoFromJSON)),
        'mncapBorrowerId': json['mncapBorrowerId'] == null ? undefined : json['mncapBorrowerId'],
        'hasSelection': json['hasSelection'] == null ? undefined : json['hasSelection'],
        'isCasLemoine': json['isCasLemoine'],
        'isEdition': json['isEdition'] == null ? undefined : json['isEdition'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function BorrowerContractFunnelV2DtoToJSON(json: any): BorrowerContractFunnelV2Dto {
    return BorrowerContractFunnelV2DtoToJSONTyped(json, false);
}

export function BorrowerContractFunnelV2DtoToJSONTyped(value?: BorrowerContractFunnelV2Dto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'pricingStatus': ComparateurPricingStatusToJSON(value['pricingStatus']),
        'product': FunnelProductDtoToJSON(value['product']),
        'fees': value['fees'] == null ? undefined : ((value['fees'] as Array<any>).map(FeesDtoToJSON)),
        'variables': value['variables'] == null ? undefined : ((value['variables'] as Array<any>).map(ReadVariablesTunnelDtoToJSON)),
        'pricing': TarificationDtoToJSON(value['pricing']),
        'loanConfigs': ((value['loanConfigs'] as Array<any>).map(LoanConfigurationDtoToJSON)),
        'guarantees': ((value['guarantees'] as Array<any>).map(GuaranteeDto1ToJSON)),
        'guaranteesReferential': value['guaranteesReferential'] == null ? undefined : ((value['guaranteesReferential'] as Array<any>).map(GuaranteeDto1ToJSON)),
        'supportId': value['supportId'],
        'supportLabel': value['supportLabel'],
        'cotisationTypeId': value['cotisationTypeId'],
        'cotisationTypeLabel': value['cotisationTypeLabel'],
        'contractIdentifier': value['contractIdentifier'],
        'matchScore': value['matchScore'],
        'missingGuarantees': value['missingGuarantees'],
        'hash': value['hash'],
        'warningMessages': value['warningMessages'],
        'borrowers': ((value['borrowers'] as Array<any>).map(BorrowerPricingDtoToJSON)),
        'mncapBorrowerId': value['mncapBorrowerId'],
        'hasSelection': value['hasSelection'],
        'isCasLemoine': value['isCasLemoine'],
        'isEdition': value['isEdition'],
        'errorMessage': value['errorMessage'],
    };
}

